import { Grid } from "@mui/material";
import MessageStore from "components/ManagerInteractions/Stores/MessageStore";
import AcxButton from "components/UI/AcxButton";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import React, { useState } from "react";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import { useCurrentDashboard } from "../../useCurrentDashboard";
import UniqueCardStore from "./UniqueCardStore";

type UniqueCardConfirmDeleteProps = {
    open: boolean;
    onClose: () => void;
    store: UniqueCardStore<any>;
};

export const UniqueCardConfirmDelete: React.FC<UniqueCardConfirmDeleteProps> =
    observer(({ open, onClose, store }) => {
        const currentDashboard = useCurrentDashboard();
        const messageStore = useStore(MessageStore);
        const [isDeleting, setIsDeleting] = useState(false);

        if (!currentDashboard) return null;

        return (
            <AcxDialog
                isOpen={open}
                onClose={onClose}
                title="Are you sure you want to delete this report?"
                subTitle="This action cannot be undone. Deleting this report will permanently remove all associated filters and selections."
            >
                <Grid container item xs={4}>
                    <AcxButton
                        fullWidth
                        color="primary"
                        loading={isDeleting}
                        onClick={async () => {
                            try {
                                setIsDeleting(true);
                                await currentDashboard.deleteSignalsObjectById(
                                    store.id,
                                );
                                messageStore.logMessage(
                                    "Report deleted",
                                    "success",
                                );
                                onClose();
                            } catch (error) {
                                messageStore.logError(
                                    "Failed to delete report. Please try again.",
                                );
                            } finally {
                                setIsDeleting(false);
                            }
                        }}
                        containerStyle={{
                            width: "215px",
                        }}
                    >
                        Confirm
                    </AcxButton>
                </Grid>
            </AcxDialog>
        );
    });

